import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/background-img.png";
import "../../assets/styles/contact.css";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { config } from "../config";
import Slider from "react-slick";
import moment from "moment";
const ProductMain = () => {
    const [product, setProduct] = useState([]);
    const [productImage, setProductImage] = useState([]);
    const { productId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(
                    // `http://localhost/elementeers_crm/api/product/${productId}`
                    `https://admin.elementeers.com/api/product/${productId}`
                );
                console.log(response.data);
                setProduct(response.data.product_details);
                setProductImage(response.data.product_images);
            } catch (err) {
                setError("Failed to fetch product details.");
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [productId]);

    let specifications = [];
    try {
        specifications = JSON.parse(product.specifications);
    } catch (e) {
        console.error("Error parsing specifications:", e);
    }
    useEffect(() => window.scrollTo(0, 0), [])
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    autoplay: true,
                    arrow: false,
                    autoplaySpeed: 2000,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrow: false,
                    autoplaySpeed: 2000,
                },
            },
        ],
    };
    return (
        <div>
            <Helmet>
                <title>Products - Elementeers Nucleons</title>
            </Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={`${product.product_name}`}
                subtitle={`${product.product_details}`}
            />
            <div className="">
                <div className="contact-info-area pb-80 pt-80">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-9">
                                <table className="table border m-0 table-product">
                                    <tbody>
                                        <tr>
                                            <td className="text-color">Product Code </td>
                                            <td>
                                                <span id="lblart">{product.artical_no}</span>
                                            </td>
                                            <td className="text-color">Grade</td>
                                            <td>
                                                <span id="lblgrade">{product.grade}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-color">Purity</td>
                                            <td>
                                                <span id="lblpurity">{product.purity}</span>
                                            </td>
                                            <td className="text-color">CAS No.
                                            </td>
                                            <td>
                                                <span id="lblcasno">{product.cas_no}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-color">Molecular Formula
                                            </td>
                                            <td>
                                                <span id="lblmolfor" className="lblmolfor">{product.molecular_formula}</span>
                                            </td>
                                            <td className="text-color">Molecular Weight
                                            </td>
                                            <td>
                                                <span id="lblmolweight">{product.molecular_weight}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                        
                                            <td className="text-color">Shelf Life
                                            </td>
                                            <td>
                                                <span id="lblshelf">{product.shelf_life}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div id="specid" className="table-responsive mb-5">
                                    <h3 className="fw-medium py-2">Specifications</h3>
                                    <table className="table border m-0 table-product">
                                        <tbody>
                                            {specifications.reduce((rows, item, index) => {
                                                if (index % 2 === 0) {
                                                    rows.push([item]);
                                                } else {
                                                    rows[rows.length - 1].push(item);
                                                }
                                                return rows;
                                            }, []).map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((item, colIndex) => (
                                                        <React.Fragment key={colIndex}>
                                                            <td className="text-color">{item.label}</td>
                                                            <td>{item.value}</td>
                                                        </React.Fragment>
                                                    ))}
                                                    {row.length === 1 && (
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                        </>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <div>
                                    <h3 id="symbolshd" className="fw-medium mb-3">Safety Information and Hazard Symbols</h3>
                                    <div className="border">
                                        <div id="divhazard">
                                            <div id="divsymbols" className="bg-light pt-2 px-3">
                                                <table id="lsthazard" cellspacing="0">
                                                    <tbody><tr>
                                                        <td className="mr-2 d-table">
                                                            <img alt="Exclamation Mark" title="Exclamation Mark" border="0" src={`${config.imageUrl}/product/${product.hazard_image1}`} width="50" height="50" />
                                                        </td>
                                                        <td>
                                                            <img alt="Exclamation Mark" title="Exclamation Mark" border="0" src={`${config.imageUrl}/product/${product.hazard_image2}`} width="50" height="50" />
                                                        </td>
                                                    </tr>
                                                    </tbody></table>
                                            </div>
                                            <div id="divsafety" className="px-3 pt-2">
                                                <div>
                                                    <span id="lblsymbol">Symbol: {product.symbol}<br /></span>
                                                    <span id="lblsignal">Signal Word: {product.signal_word}<br /></span>
                                                    <span id="lblun">UN No.: {product.un_no}<br /></span>
                                                    <span id="lblimco">IMCO Class No.: {product.imco_class}<br /></span>
                                                    <span id="lblpacking">Packing Group: {product.packing_group}<br /></span>
                                                    <span id="lblhazard">Hazardous Statement: {product.hazardous_statement}<br /></span>
                                                    <span id="lblprecation">Precaution Statement: {product.precaution_statement}<br /></span>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="bg-secondary py-1 px-3 text-white mt-2">
                                            <span id="lblrev">Revision Date:</span>&nbsp;<span id="lbldate">{moment(product.revision_date).format("DD-MMM-YYYY")}</span>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-md-3 top-drop">
                                <div className="row justify-content-between mb-5">
                                    <div className="dropdown col">
                                        <button className="btn btn-primary rounded-0 p-2 px-xl-5 px-md-4 px-3 shadow-none w-100" type="button">
                                            MSDS
                                        </button>
                                    </div>
                                    <div className="col">
                                        <a href="../laboratory-chemicals/coa-product.aspx?prod_id=3193&amp;prod=3193" className="btn btn-primary py-2 px-xl-5 px-md-4 px-3 rounded-0 shadow-none w-100">COAs</a>
                                    </div>
                                </div>
                                <div id="divpacking">
                                    <h3 class="fw-medium pb-2">Packings</h3>
                                    <div class="bg-light p-1">
                                        <div id="example1" class="slider-pro sp-horizontal">
                                            <div class="sp-slides-container">
                                                <div class="sp-mask">
                                                    <div class="sp-slides">
                                                        <Slider {...settings}>
                                                            {productImage.map((slide, index) => (
                                                                <div key={index} className="sp-slide">
                                                                    <div className="sp-image-container">
                                                                        <a href={slide.image} className="facybox" data-rel="gal">
                                                                            <img className="sp-image" src={`${config.imageUrl}/product/sliders/${slide.image}`} alt={`${slide.image}`} width={"100%"} />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </Slider>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ProductMain;
